import { ReactNode } from 'react';
import { AlignProp, VariantProp, Align } from './Modal';
import { cn } from '../../utils';
import { Dialog } from '@headlessui/react';
import Icon from './Icon';

type ModalContentProps = {
    title: string;
    message?: ReactNode[] | ReactNode;
    icon?: boolean | ReactNode;
    children?: ReactNode;
} & AlignProp &
    VariantProp;

export default function Body({
    title,
    message,
    align,
    icon,
    variant,
    children,
}: ModalContentProps) {
    const isLeft = align === Align.LEFT;
    const isCenter = align === Align.CENTER;
    return (
        <div
            data-testid="modal-body"
            className={cn({
                'alli-flex sm:alli-items-start': isLeft,
                'alli-gap-6': icon,
            })}>
            {variant && icon ? <Icon variant={variant} /> : icon}
            <div
                className={cn('alli-mt-3 alli-text-center', {
                    'sm:alli-mt-0 sm:alli-text-left': isLeft,
                    'sm:alli-mt-5': isCenter,
                    'alli-w-full': children,
                })}>
                <Dialog.Title
                    as="h3"
                    className="alli-text-base alli-font-semibold alli-leading-6 alli-text-blue-gray-700">
                    {title}
                </Dialog.Title>
                {message && (
                    <div className="alli-mt-2 alli-text-pretty">
                        <div className="alli-text-sm alli-text-gray-750">
                            {message}
                        </div>
                    </div>
                )}
                {children && <>{children}</>}
            </div>
        </div>
    );
}
